<template lang="pug">
  section.p_gallery
    .p_gallery-inner#gallery
      .p_gallery-header._fade.fade_in.scale
        .c_inner
          h2.p_gallery-heading.c_heading1
            span.p_gallery-heading-text.c_heading1-text Gallery
      .p_gallery-body._fade.fade_in.scale
          .p_gallery-slider
            slick(ref="slick",
              :options="slickOptions",
              @afterChange="handleAfterChange"
              @beforeChange="handleBeforeChange"
              @breakpoint="handleBreakpoint"
              @destroy="handleDestroy"
              @edge="handleEdge"
              @init="handleInit"
              @reInit="handleReInit"
              @setPosition="handleSetPosition"
              @swipe="handleSwipe"
              @lazyLoaded="handleLazyLoaded"
              @lazyLoadError="handleLazeLoadError")
              .p_sld(v-for="(val, key) in $store.state.gallery.length", ref="image")
                router-link.p_sld-inner(:to="{ query: { id: (key+1), modal: true } }")
                  .p_sld-image
                    span.-image
                      img(:src="getImage('/top/gallery', '/img' + (key+1) + '.jpg', '')")
</template>

<script>
import Slick from '@/components/slickCarousel'
export default {
  name: 'TheGallery',
  components: {
    Slick,
  },
  '$store.state.isSmartPhone': function () {
    this.padding = (this.$store.state.isSmartPhone) ? 20 : 40
    this.handleInit()
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        speed: 800,
        dotsClass: '',
        prevArrow: '<button type="button" class="p_gallery-btn-prev p_gallery-btn"><i class="-arr"><span class="prev u_rotate-45-l"></span></i></button>',
        nextArrow: '<button type="button", class="p_gallery-btn-next p_gallery-btn"><i class="-arr"><span class="next u_rotate-45-r"></span></i></button>',
        responsive: [
          {
            // for SP
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              centerMode: false,
              infinite: true,
            }
          },
        ]
      },
      padding: 0,
      slickObj: {},
    }
  },
  watch: {
    '$store.state.isSmartPhone': function () {
      let _self = this
      let slickTarget = _self.$refs.slick
      slickTarget.destroy()
      this.$nextTick(() => {

        slickTarget.create()

        let el = _self.$refs.image
        let current = _self.slickObj.currentSlide

        this.setSlickStyle(el, current)
      })
    }
  },
  mounted () {
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
        this.$refs.slick.prev();
    },
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    setSlickStyle (el, current) {
      let _self = this
      _self.padding = (this.$store.state.isSmartPhone) ? 20 : 40

      let showLengths = {
        sp: _self.slickOptions.responsive[0].settings.slidesToShow,
        pc: _self.slickOptions.slidesToShow
      }
      let showLength = (_self.$store.state.isSmartPhone) ? showLengths.sp : showLengths.pc
      let allLength = _self.$refs.image.length

      for (var i = 0; i < showLength; i++) {
        TweenMax.set(el[current + i], { paddingTop: _self.padding * i })
      }
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      let _self = this
      let active = _self.$el.querySelectorAll('.slick-active')
      let slide = _self.$el.querySelectorAll('.slick-slide')
      // TweenMax.set(active[0].querySelector('.p_sld'), {
      //   paddingBottom: (_self.padding * (active.length - 1)),
      // })
      for (var i = 0; i < active.length; i++) {
        TweenMax.to(active[i].querySelector('.p_sld'), .3, { paddingTop: 0 })
      }
      TweenMax.to(slide, .3, { opacity: 0 })
      this.slickObj = slick
    },
    handleInit(event, slick) {
      let _self = this
      let el = _self.$refs.image
      let current = slick.currentSlide
      this.slickObj = slick

      this.$nextTick(() => this.setSlickStyle(el, current))
    },
    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      let _self = this
      let active = this.$el.querySelectorAll('.slick-active')
      let slide = this.$el.querySelectorAll('.slick-slide')
      this.slickObj = slick
      for (var i = 0; i < active.length; i++) {
        // TweenMax.set(active[i].querySelector('.p_sld'), {
        //   paddingTop: _self.padding * i,
        // })
        TweenMax.to(active[i].querySelector('.p_sld'), .6, {
          paddingTop: _self.padding * i,
          // delay: .1 * i,
          ease: Power1.linear
        })
        TweenMax.to(active[i].querySelector('.p_sld'), .3, {
          // opacity: 1,
          // delay: .4 * i,
          // ease: Power1.linear
        })
      }
      TweenMax.to(slide, 1, { opacity: 1, })
    },
    handleBreakpoint(event, slick, breakpoint) {},
    handleDestroy(event, slick) {},
    handleEdge(event, slick, direction) {},
    handleReInit(event, slick) {
    },
    handleSetPosition(event, slick) {},
    handleSwipe(event, slick, direction) {},
    handleLazyLoaded(event, slick, image, imageSource) {},
    handleLazeLoadError(event, slick, image, imageSource) {},
  }
}
</script>

<style lang="scss" scoped>
.p_gallery {
  @include pc {
    margin: cal(-60,1400) 0 0;
    padding: vw(260,1400) 0 vw(228,1400);
    background: url("../../../static/img/top/img2_bg.jpg") center center no-repeat fixed;
    background-size: cover;
  }
  @include sp {
    padding: vw(204,750) 0 vw(327,750);
    background: url("../../../static/img/top/sp/img2_bg.jpg") center center no-repeat;
    background-size: cover;
  }
  position: relative;

  &::before {
    @include pc {
      height: vw(260,1400);
      background: url("../../../static/img/top/bg2.png") center bottom no-repeat;
      background-size: cover;
    }
    @include sp {
      height: vw(204,750);
      background: url("../../../static/img/top/sp/bg2.png") center bottom no-repeat;
      background-size: cover;
    }
    content: "";
    display: block;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: -1px;
  }

  &-inner {
    @include pc {
      padding: 0 0 vw(94,1400);
    }
    @include sp {
      padding: 0 0 vw(88,750);
    }
  }

  &-header {
    text-align: center;
  }

  &-heading {
    &-text {
      @include pc {}
      color: #fff;
      letter-spacing: $ltsp2;
    }
  }

  &-body {
    @include pc {
      height: vw(300,1024);
      min-height: rem(300);
      padding: rem(40) 0 0;
    }
    @include sp {
      // min-height: vw(276,768);
      min-height: calc(35.9375vw + 60px);
      // height: vw(417,750);
      // min-height: rem(420,2);
      margin: vw(65,750) 0 0;
    }
    position: relative;
  }

  &-slider {
    @include sp {
    }
  }
}

.p_sld {
  @include pc {
  }
  display: block;

  &-inner {
    @include sp {
      padding: 0 10px;
    }
    @include pc {
      padding: 0 6px;
    }
  }

  &-image {
    @include pc {
      padding: 0 rem(15) rem(15) 0;
    }
    @include sp {
      padding: 0 rem(8) rem(8) 0;
    }
    position: relative;
    line-height: 0;

    &::before {
      @include pc {
        width: calc(100% - 15px);
        height: calc(100% - 15px);
      }
      @include sp {
        width: calc(100% - 8px);
        height: calc(100% - 8px);
      }
      @include box_shadow();
      content: "";
      display: block;
      position: absolute;
      background: $palet2;
      right: rem(0);
      bottom: rem(0);
    }

    .-image {
      position: relative;
    }
  }
}
</style>

<style lang="scss">
.p_gallery {
  .slick-slider {
  }

  &-btn {
    @include pc {
      top: rem(100);
    }
    @include sp {
      bottom: rem(0);
    }
    width: rem(60);
    height: rem(60);
    background: $palet1;
    display: block;
    position: absolute;
    z-index: 999;

    &:hover {
      @include pc {
        @include hover();
      }
    }

    .-arr {
      width: rem(18);
      height: rem(18);
      display: block;
      position: absolute;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &-prev {
      @include pc {
        right: rem(61);
      }
      @include sp {
        right: rem(61+25);
      }

      .prev {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        display: block;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff #fff transparent transparent;
      }
    }

    &-next {
      @include pc {
        right: rem(0);
      }
      @include sp {
        right: rem(25);
      }

      .next {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        display: block;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff #fff transparent transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top/TheGallery.vue